import t from"./_nativeCreate.js";var a="__lodash_hash_undefined__";function _(_,i){var s=this.__data__;return this.size+=this.has(_)?0:1,s[_]=t&&void 0===i?a:i,this}export{_ as default};
//# sourceMappingURL=_hashSet.js.map
